import React from 'react';

import RelatorioSecoesView from 'components/Relatorios/shared/Aprovacao/RelatorioSecoesView';

/**
 * Aba "Informe DESSEM": delega às sub-abas/aprovação genéricas
 * (`RelatorioSecoesView`), configuradas em `helper/Relatorios/Aprovacao/config`.
 */
export default function DessemView() {
  return <RelatorioSecoesView informe="dessem" />;
}
